export function getContractLengthInMonths(
  fromDate: string | Date,
  toDate?: string | Date,
) {
  const from = new Date(fromDate);
  const to = toDate ? new Date(toDate) : new Date();

  let months =
    (to.getFullYear() - from.getFullYear()) * 12 +
    (to.getMonth() - from.getMonth());
  if (to.getDate() < from.getDate()) {
    months -= 1;
  }

  return Math.max(0, months);
}

export function compareContractLength(
  a: { fromDate: string | Date; toDate?: string | Date },
  b: { fromDate: string | Date; toDate?: string | Date },
  direction: "asc" | "desc",
) {
  const result =
    getContractLengthInMonths(a.fromDate, a.toDate) -
    getContractLengthInMonths(b.fromDate, b.toDate);
  return direction === "asc" ? result : -result;
}

export function formatContractLength(
  fromDate: string | Date,
  toDate: string | Date | undefined,
  locale: { year: string; years: string; month: string; months: string },
) {
  const totalMonths = getContractLengthInMonths(fromDate, toDate);
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  return `${years} ${years === 1 ? locale.year : locale.years}, ${months} ${
    months === 1 ? locale.month : locale.months
  }`;
}
